import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStoreService {
  private ls = window.localStorage;

  constructor() {}

    public setItem(key: any, value: any) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  public getItem(key:any) {
    const value = this.ls.getItem(key);
    try {
        if (typeof value === 'string') {
            return JSON.parse(value);
        }
        else {
            return null;
        }
    } catch (e) {
      return null;
    }
  }

    public removeItem(key: any) {
      
        try {
            this.ls.removeItem(key);
        } catch (e) {
            return ;
        }
    }

  public clear() {
    this.ls.clear();
  }
}
